import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClasses } from '../../features/classes/ClassSlice';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { getLabelsByInstituteType } from '../../utils/constants';
import {
  deleteHomeWorkDetails,
  getHomeWorkDetails,
  postHomeWorkDetails,
  updateHomeWorkDetails,
} from '../../features/mobile/mobileSlice';
import useNotification from '../../hooks/useNotification';
import ToastNotification from '../UIElements/ToastNotification';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { MenuProps } from '../../utils/constants';
import useConfirmationDialog from '../../hooks/useConfirmationDialog';
import ConfirmationDialog from '../UIElements/ConfirmationDialog';
const HomeWorkTab = () => {
  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({
    departmentName: '',
    className: '',
    sectionName: '',
    date: '',
    subject: '',
    title: '',
    description: '',
  });
  const topRef = useRef(null);

  const [loading, setloading] = useState(false);
  const [isRetrieving, setIsRetrieving] = useState(false);
  const [classDetails, setClassDetails] = useState([]);
  const [currentDepartment, setCurrentDepartment] = useState({});
  const [currentClasses, setCurrentClasses] = useState([]);
  const [currentSections, setCurrentSections] = useState([]);
  const [homeWorkDetails, setHomeWorkDetails] = useState([]);
  const [viewError, setViewError] = useState('');
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  let { Department, Class, Section } = getLabelsByInstituteType(instituteType);
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  const { dialog, showDeleteConfirmation, closeDialog } =
    useConfirmationDialog();
  useEffect(() => {
    (async () => {
      const response = await dispatch(getClasses()).unwrap();
      response == 'error' ? setClassDetails([]) : setClassDetails(response);
    })();
  }, []);
  const goToSection = () => {
    topRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };
  const submitHomeWork = async (values, resetForm) => {
    try {
      await dispatch(postHomeWorkDetails(values)).unwrap();
      showSuccess('HomeWork Details Submitted Successfully');
      resetForm();
    } catch (error) {
      console.log(error);
      showError('Error in Submitting HomeWork Details');
    } finally {
      setloading(false);
    }
  };
  const updateHomeWork = async (values, resetForm) => {
    try {
      await dispatch(updateHomeWorkDetails(values)).unwrap();
      showSuccess('HomeWork Details  Updated Successfully');
      getHomeWork({
        departmentName: values.departmentName,
        className: values.className,
        sectionName: values.sectionName,
        workDate: values.date,
      });
      resetForm();
      setDefaultValues({
        departmentName: '',
        className: '',
        sectionName: '',
        date: '',
        subject: '',
        title: '',
        description: '',
      });
    } catch (error) {
      console.log(error);
      showError('Error in Updating HomeWork Details');
    } finally {
      setloading(false);
    }
  };
  const getHomeWork = async (values) => {
    setIsRetrieving(true);
    try {
      const response = await dispatch(getHomeWorkDetails(values)).unwrap();
      setHomeWorkDetails(response);
      if (response.length == 0)
        setViewError(
          <h6 className='text-red-500 text-center mt-8'>
            No Homework Available for selected Details.
          </h6>,
        );
      else setViewError('');
    } catch (error) {
      console.log(error);
      showError('Error in Getting HomeWork Details');
    } finally {
      setIsRetrieving(false);
    }
  };
  const deleteHomeWork = async (obj) => {
    try {
      const response = await dispatch(deleteHomeWorkDetails(obj.id)).unwrap();
      response
        ? (showSuccess('Homework deleted Successfully'),
          getHomeWork({
            departmentName: obj.departmentName,
            className: obj.className,
            sectionName: obj.sectionName,
            workDate: obj.date,
          }),
          closeDialog())
        : showError('Error in deleting the Announcement');
    } catch (error) {
      console.log(error);
      showError('Somehting went wrong!');
    }
  };
  return (
    <>
      <div ref={topRef} className='scroll-mt-28'></div>

      <div className='flex flex-col  max-[1100px]:flex-col justify-between  gap-4 max-w-4xl '>
        <div className=''>
          <Accordion className=' p-4 '>
            <Formik
              initialValues={{ ...defaultValues }}
              validationSchema={Yup.object({
                departmentName: Yup.string().required(`Select ${Department} `),
                className: Yup.string().required(`Select ${Class} `),
                sectionName:
                  instituteType?.toLowerCase() == 'college'
                    ? Yup.string().required(`Select ${Section}`)
                    : Yup.string(),
                date: Yup.date().required(`Select Date `),
                subject: Yup.string()
                  .max(20, 'maximum length is upto 20 Characters')
                  .required('Enter Subject name'),
                title: Yup.string().required('Enter work Details name'),
                description: Yup.string().max(
                  250,
                  'Max Characters should be below 250',
                ),
              })}
              enableReinitialize={true}
              onSubmit={async (values, { resetForm }) => {
                setloading(true);
                if (!values?.id) {
                  submitHomeWork(values, resetForm);
                } else {
                  updateHomeWork(values, resetForm);
                }
              }}
            >
              {({ setFieldValue, resetForm }) => (
                <>
                  <Typography className='mb-4 text-lg' color='success'>
                    Add and Modifiy Home Work details
                  </Typography>
                  <Form>
                    <div className='  flex flex-col gap-y-4'>
                      {' '}
                      <div className='flex gap-4 mb-2 max-[500px]:flex-col'>
                        <Field name='departmentName'>
                          {({ field, meta }) => (
                            <FormControl
                              fullWidth
                              size='small'
                              required
                              error={meta.touched && Boolean(meta.error)}
                            >
                              <InputLabel
                                id='class-label'
                                shrink={true}
                                className='font-medium'
                              >
                                {Department}
                              </InputLabel>
                              <Select
                                MenuProps={MenuProps}
                                displayEmpty
                                labelId='class-label'
                                {...field}
                                value={field.value}
                                label={Department}
                                onChange={(e) => {
                                  const dept = classDetails?.find(
                                    (obj) => obj.department === e.target.value,
                                  );
                                  setCurrentDepartment(dept);
                                  setCurrentClasses(dept?.classes);
                                  setFieldValue(
                                    'departmentName',
                                    e.target.value,
                                  );
                                  setFieldValue('className', '');
                                }}
                              >
                                {classDetails?.length == 0 && (
                                  <MenuItem value=''>{` No ${Department} Available`}</MenuItem>
                                )}
                                {classDetails?.length !== 0 && (
                                  <MenuItem value=''>{` --- Select  ${Department} ---`}</MenuItem>
                                )}
                                {classDetails?.length > 0 &&
                                  classDetails?.map((obj) => (
                                    <MenuItem
                                      key={obj.id}
                                      value={obj.department}
                                    >
                                      {obj.department}
                                    </MenuItem>
                                  ))}
                              </Select>
                              {meta.touched && meta.error && (
                                <small className='text-red-600'>
                                  {meta.error}
                                </small>
                              )}
                            </FormControl>
                          )}
                        </Field>

                        <Field name='className'>
                          {({ field, meta }) => (
                            <FormControl
                              fullWidth
                              size='small'
                              required
                              error={meta.touched && Boolean(meta.error)}
                            >
                              <InputLabel shrink={true}>{Class}</InputLabel>
                              <Select
                                MenuProps={MenuProps}
                                displayEmpty
                                {...field}
                                value={field.value || ''}
                                label={Class}
                                onChange={(e) => {
                                  const Class = currentClasses?.find(
                                    (obj) => obj.className === e.target.value,
                                  );
                                  setCurrentSections(Class?.sections);
                                  setFieldValue('className', e.target.value);
                                }}
                              >
                                {currentClasses?.length == 0 && (
                                  <MenuItem value=''>{` --- First Select  ${Department} ---`}</MenuItem>
                                )}
                                {currentClasses?.length !== 0 && (
                                  <MenuItem value=''>{` --- Select  ${Class} ---`}</MenuItem>
                                )}
                                {currentDepartment?.classes?.map((obj) => (
                                  <MenuItem key={obj.id} value={obj.className}>
                                    {obj.className}
                                  </MenuItem>
                                ))}
                              </Select>
                              {meta.touched && meta.error && (
                                <small className='text-red-600'>
                                  {meta.error}
                                </small>
                              )}
                            </FormControl>
                          )}
                        </Field>
                      </div>
                      <div className='flex gap-4 max-[500px]:flex-col'>
                        {instituteType.toLowerCase() === 'college' && (
                          <Field name='sectionName'>
                            {({ field, meta }) => (
                              <FormControl
                                fullWidth
                                required
                                size='small'
                                error={meta.touched && Boolean(meta.error)}
                              >
                                <InputLabel
                                  id='class-label'
                                  shrink={true}
                                  className='font-medium'
                                >
                                  {Section}
                                </InputLabel>
                                <Select
                                  MenuProps={MenuProps}
                                  displayEmpty
                                  labelId='class-label'
                                  {...field}
                                  value={field.value}
                                  label={Section}
                                  onChange={(e) => {
                                    setFieldValue(
                                      'sectionName',
                                      e.target.value,
                                    );
                                  }}
                                >
                                  {currentSections?.length == 0 && (
                                    <MenuItem value=''>{` ---First Select  ${Class} ---`}</MenuItem>
                                  )}
                                  {currentSections?.length !== 0 && (
                                    <MenuItem value=''>{` --- Select  ${Section} ---`}</MenuItem>
                                  )}
                                  {currentSections?.map((obj) => (
                                    <MenuItem key={obj.id} value={obj.section}>
                                      {obj.section}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {meta.touched && meta.error && (
                                  <small className='text-red-600'>
                                    {meta.error}
                                  </small>
                                )}
                              </FormControl>
                            )}
                          </Field>
                        )}{' '}
                        <Field name='date' fullWidth>
                          {({ field, meta }) => (
                            <TextField
                              fullWidth
                              type='date'
                              value={field.value}
                              name={field.name}
                              size='small'
                              label='Date'
                              required
                              error={meta.touched && !!meta.error}
                              helperText={(meta.touched && meta.error) || ''}
                              onChange={field.onChange}
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        </Field>
                        {instituteType.toLowerCase() !== 'college' && (
                          <Field name='subject'>
                            {({ field, meta }) => (
                              <TextField
                                {...field}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                size='small'
                                placeholder='Enter Subject Name'
                                label='Subject'
                                required
                                onChange={field.onChange}
                                helperText={meta.touched && meta.error}
                                error={meta.touched && Boolean(meta.error)}
                              ></TextField>
                            )}
                          </Field>
                        )}
                      </div>
                      {instituteType.toLowerCase() === 'college' && (
                        <Field name='subject'>
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              InputLabelProps={{ shrink: true }}
                              fullWidth
                              size='small'
                              placeholder='Enter Subject Name'
                              label='Subject'
                              required
                              onChange={field.onChange}
                              helperText={meta.touched && meta.error}
                              error={meta.touched && Boolean(meta.error)}
                            ></TextField>
                          )}
                        </Field>
                      )}
                      <Field name='title'>
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            placeholder='Enter Work Details'
                            multiline
                            label='Work'
                            required
                            onChange={field.onChange}
                            helperText={meta.touched && meta.error}
                            error={meta.touched && Boolean(meta.error)}
                            InputLabelProps={{ shrink: true }}
                          ></TextField>
                        )}
                      </Field>
                      <Field name='description'>
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            minRows={3}
                            maxRows={4}
                            multiline
                            sx={{
                              '& textarea': {
                                resize: 'both', // options: none | vertical | horizontal | both
                              },
                            }}
                            placeholder='Enter Detailed Description here..'
                            label='Description'
                            InputLabelProps={{ shrink: true }}
                            onChange={field.onChange}
                            helperText={meta.touched && meta.error}
                            error={meta.touched && Boolean(meta.error)}
                          ></TextField>
                        )}
                      </Field>
                      <div className=''></div>
                      <div className='ml-auto'>
                        <Button
                          color='error'
                          variant='outlined'
                          onClick={() => {
                            // thisis for resetting default values during edit so the form clear else intialvalues takes vales of default values
                            setDefaultValues({
                              departmentName: '',
                              className: '',
                              sectionName: '',
                              date: '',
                              subject: '',
                              title: '',
                              description: '',
                            });

                            resetForm();
                          }}
                        >
                          Clear
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          type='submit'
                          variant='contained'
                          loading={loading}
                          loadingIndicator='Submitting'
                        >
                          {loading ? 'Submitting' : 'Submit'}
                        </Button>
                      </div>
                    </div>
                  </Form>
                  <ToastNotification
                    open={notification.open}
                    onClose={hideNotification}
                    message={notification.message}
                    title={notification.title}
                    severity={notification.severity}
                    autoHideDuration={notification.autoHideDuration}
                    position={notification.position}
                  />
                </>
              )}
            </Formik>
          </Accordion>
        </div>
        <div>
          {' '}
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1-content'
              id='panel1-header'
            >
              <Typography color='success' className='text-lg'>
                View HomeWork Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <p className='font-semibold'>
                {' '}
                Select class details and search to view HomeWork details.
              </p>
              <Formik
                initialValues={{
                  departmentName: '',
                  className: '',
                  sectionName: '',
                  workDate: '',
                }}
                validationSchema={Yup.object({
                  departmentName: Yup.string().required(
                    `Select ${Department} `,
                  ),
                  className: Yup.string().required(`Select ${Class} `),
                  sectionName:
                    instituteType?.toLowerCase() == 'college'
                      ? Yup.string().required(`Select ${Section}`)
                      : Yup.string(),
                  workDate: Yup.date().required(`Select Date `),
                })}
                onSubmit={(values) => {
                  getHomeWork(values);
                }}
              >
                {({ setFieldValue }) => (
                  <>
                    <Form>
                      <div className='  flex flex-col gap-y-4 mt-4'>
                        {' '}
                        <div className='flex gap-4 mb-2 max-[500px]:flex-col'>
                          <Field name='departmentName'>
                            {({ field, meta }) => (
                              <FormControl
                                fullWidth
                                size='small'
                                required
                                error={meta.touched && Boolean(meta.error)}
                              >
                                <InputLabel
                                  id='class-label'
                                  shrink={true}
                                  className='font-medium'
                                >
                                  {Department}
                                </InputLabel>
                                <Select
                                  MenuProps={MenuProps}
                                  displayEmpty
                                  labelId='class-label'
                                  {...field}
                                  value={field.value}
                                  label={Department}
                                  onChange={(e) => {
                                    const dept = classDetails?.find(
                                      (obj) =>
                                        obj.department === e.target.value,
                                    );
                                    setCurrentDepartment(dept);
                                    setCurrentClasses(dept?.classes);
                                    setFieldValue(
                                      'departmentName',
                                      e.target.value,
                                    );
                                    setFieldValue('className', '');
                                  }}
                                >
                                  {classDetails?.length == 0 && (
                                    <MenuItem value=''>{` No ${Department} Available`}</MenuItem>
                                  )}
                                  {classDetails?.length !== 0 && (
                                    <MenuItem value=''>{` --- Select  ${Department} ---`}</MenuItem>
                                  )}
                                  {classDetails?.length > 0 &&
                                    classDetails?.map((obj) => (
                                      <MenuItem
                                        key={obj.id}
                                        value={obj.department}
                                      >
                                        {obj.department}
                                      </MenuItem>
                                    ))}
                                </Select>
                                {meta.touched && meta.error && (
                                  <small className='text-red-600'>
                                    {meta.error}
                                  </small>
                                )}
                              </FormControl>
                            )}
                          </Field>

                          <Field name='className'>
                            {({ field, meta }) => (
                              <FormControl
                                fullWidth
                                size='small'
                                required
                                error={meta.touched && Boolean(meta.error)}
                              >
                                <InputLabel shrink={true}>{Class}</InputLabel>
                                <Select
                                  MenuProps={MenuProps}
                                  displayEmpty
                                  {...field}
                                  value={field.value || ''}
                                  label={Class}
                                  onChange={(e) => {
                                    const Class = currentClasses?.find(
                                      (obj) => obj.className === e.target.value,
                                    );
                                    setCurrentSections(Class?.sections);
                                    setFieldValue('className', e.target.value);
                                  }}
                                >
                                  {currentClasses?.length == 0 && (
                                    <MenuItem value=''>{` --- First Select  ${Department} ---`}</MenuItem>
                                  )}
                                  {currentClasses?.length !== 0 && (
                                    <MenuItem value=''>{` --- Select  ${Class} ---`}</MenuItem>
                                  )}
                                  {currentDepartment?.classes?.map((obj) => (
                                    <MenuItem
                                      key={obj.id}
                                      value={obj.className}
                                    >
                                      {obj.className}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {meta.touched && meta.error && (
                                  <small className='text-red-600'>
                                    {meta.error}
                                  </small>
                                )}
                              </FormControl>
                            )}
                          </Field>
                        </div>
                        <div className='flex gap-4 max-[500px]:flex-col'>
                          {instituteType.toLowerCase() === 'college' && (
                            <Field name='sectionName'>
                              {({ field, meta }) => (
                                <FormControl
                                  fullWidth
                                  required
                                  size='small'
                                  error={meta.touched && Boolean(meta.error)}
                                >
                                  <InputLabel
                                    id='class-label'
                                    shrink={true}
                                    className='font-medium'
                                  >
                                    {Section}
                                  </InputLabel>
                                  <Select
                                    MenuProps={MenuProps}
                                    displayEmpty
                                    labelId='class-label'
                                    {...field}
                                    value={field.value}
                                    label={Section}
                                    onChange={(e) => {
                                      setFieldValue(
                                        'sectionName',
                                        e.target.value,
                                      );
                                    }}
                                  >
                                    {currentSections?.length == 0 && (
                                      <MenuItem value=''>{` ---First Select  ${Class} ---`}</MenuItem>
                                    )}
                                    {currentSections?.length !== 0 && (
                                      <MenuItem value=''>{` --- Select  ${Section} ---`}</MenuItem>
                                    )}
                                    {currentSections?.map((obj) => (
                                      <MenuItem
                                        key={obj.id}
                                        value={obj.section}
                                      >
                                        {obj.section}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {meta.touched && meta.error && (
                                    <small className='text-red-600'>
                                      {meta.error}
                                    </small>
                                  )}
                                </FormControl>
                              )}
                            </Field>
                          )}{' '}
                          <Field name='workDate' fullWidth>
                            {({ field, meta }) => (
                              <TextField
                                fullWidth
                                type='date'
                                value={field.value}
                                name={field.name}
                                size='small'
                                label={field.value}
                                required
                                error={meta.touched && !!meta.error}
                                helperText={(meta.touched && meta.error) || ''}
                                onChange={field.onChange}
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                          </Field>
                          {instituteType.toLowerCase() !== 'college' && (
                            <div className=' w-full text-end'>
                              <Button
                                type='submit'
                                color='success'
                                variant='contained'
                                loading={isRetrieving}
                                loadingIndicator='Loading..'
                                className='px-3'
                              >
                                {isRetrieving ? ' Loading... ' : ' Search '}
                              </Button>
                            </div>
                          )}
                        </div>
                        {instituteType.toLowerCase() === 'college' && (
                          <div className=' w-full text-end'>
                            <Button
                              type='submit'
                              color='success'
                              variant='contained'
                              loading={isRetrieving}
                              loadingIndicator='Loading..'
                              className='ml-auto px-4'
                            >
                              {isRetrieving ? ' Loading... ' : ' Search '}
                            </Button>
                          </div>
                        )}
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
              <div>
                {viewError ? (
                  viewError
                ) : (
                  <>
                    {homeWorkDetails.length == 0 ? (
                      <h6 className='text-blue-500 text-center mt-8'>
                        ------No HomeWork Available---------
                      </h6>
                    ) : (
                      ''
                    )}
                  </>
                )}
              </div>
              {homeWorkDetails.length > 0 && (
                <div className='my-10'>
                  <Typography
                    variant='h4'
                    component='h1'
                    className='mb-2 font-medium text-lg lg:text-2xl'
                  >
                    HomeWork details:
                  </Typography>
                  <div className='overflow-x-auto grid'>
                    <TableContainer
                      component={Paper}
                      variant='outlined'
                      sx={{
                        maxHeight: '50vh',

                        overflow: 'auto',
                      }}
                    >
                      <Table stickyHeader size='small' sx={{ minWidth: 400 }}>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                            <TableCell>
                              <strong>SNo.</strong>
                            </TableCell>
                            <TableCell>
                              <strong>Subject</strong>
                            </TableCell>
                            <TableCell>
                              <strong>Work</strong>
                            </TableCell>
                            <TableCell>
                              <strong>Description</strong>
                            </TableCell>
                            <TableCell>
                              <strong>Actions</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {homeWorkDetails?.map((obj, index) => (
                            <TableRow
                              key={obj.id}
                              hover
                              sx={{
                                '&:nth-of-type(odd)': {
                                  backgroundColor: '#fafafa',
                                },
                              }}
                            >
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{obj.subject}</TableCell>
                              <TableCell className='truncate max-w-[230px] '>
                                <span title={obj.title}>
                                  {obj.title || '--'}
                                </span>
                              </TableCell>
                              <TableCell className='truncate max-w-[220px] '>
                                <span title={obj.description}>
                                  {obj.description}
                                </span>
                              </TableCell>

                              <TableCell>
                                <EditIcon
                                  className='text-blue-400 cursor-pointer text-center'
                                  onClick={() => {
                                    setDefaultValues(obj);
                                    goToSection();
                                  }}
                                />
                                <DeleteForeverIcon
                                  className='text-red-400 cursor-pointer text-center'
                                  onClick={() =>
                                    showDeleteConfirmation(obj?.subject, () =>
                                      deleteHomeWork(obj),
                                    )
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      </div>

      <ConfirmationDialog
        open={dialog.open}
        onClose={closeDialog}
        onConfirm={dialog.onConfirm}
        title={dialog.title}
        message={dialog.message}
        severity={dialog.severity}
        confirmText={dialog.confirmText}
        cancelText={dialog.cancelText}
        loading={loading}
      />
    </>
  );
};
export default HomeWorkTab;
